<template>
  <div>

    <Head title="Configurações" />
    <div class="shadow_box rounded-lg p-6">


      <h1 class="mb-6 text-2xl uppercase text-gray-777 font-roboto">Configurações</h1>

      <form @submit.prevent="update">
        <div class="w-full flex flex-col-reverse lg:flex-row gap-6">
          <div class="flex flex-1 flex-wrap mb-4 px-4">
            <percentual-input
              v-model="form.commission_global"
              :error="form.errors.commission_global"
              class="w-full"
              label="Comissão" />

            <money-input
              v-model="form.commission_minimum_global"
              :error="form.errors.commission_minimum_global"
              class="mt-6 w-full"
              label="Valor Mínimo da Comissão" />

            <vue-select-input
              :searchable="false"
              :clearable="false"
              v-model="form.interface_color_admin"
              :options="colors"
              :error="form.errors.interface_color_admin"
              class="mt-6 w-full"
              label="Cor da interface do Painel do Administrador" text="nenhuma cor encontrada">
                <template #option="{ id, name, colorPrimary }">
                  <div class="w-4 h-4 mr-2 rounded inline-block" :style="'background-color:' + colorPrimary">
                  </div>
                  {{ name }}
                </template>
                <template #selected-option="{ id, name, colorPrimary }">
                  <div class="w-4 h-4 mr-2 rounded inline-block" :style="'background-color:' + colorPrimary">
                  </div>
                  {{ name }}
                </template>
            </vue-select-input>

            <vue-select-input
              :searchable="false"
              :clearable="false"
              v-model="form.interface_color_professional"
              :options="colors"
              :error="form.errors.interface_color_professional"
              class="mt-6 w-full"
              label="Cor da interface do Painel do Profissional"
              text="nenhuma cor encontrada">
                <template #option="{ id, name, colorPrimary }">
                  <div class="w-4 h-4 mr-2 rounded inline-block" :style="'background-color:' + colorPrimary">
                  </div>
                  {{ name }}
                </template>
                <template #selected-option="{ id, name, colorPrimary }">
                  <div class="w-4 h-4 mr-2 rounded inline-block" :style="'background-color:' + colorPrimary">
                  </div>
                  {{ name }}
                </template>
            </vue-select-input>

            <vue-select-input
              :searchable="false"
              :clearable="false"
              v-model="form.interface_color_app"
              :options="colors"
              :error="form.errors.interface_color_app" class="mt-6 w-full"
              label="Cor da interface do Aplicativo do Paciente"
              text="nenhuma cor encontrada">
                <template #option="{ id, name, colorPrimary }">
                  <div class="w-4 h-4 mr-2 rounded inline-block" :style="'background-color:' + colorPrimary">
                  </div>
                  {{ name }}
                </template>

                <template #selected-option="{ id, name, colorPrimary }">
                  <div class="w-4 h-4 mr-2 rounded inline-block" :style="'background-color:' + colorPrimary">
                  </div>
                  {{ name }}
                </template>
            </vue-select-input>
          </div>

          <whatsapp-connect class="flex-1">
          </whatsapp-connect>
        </div>

        <div class="mt-10 pt-4 border-t border-t-gray-777">
          <h1 class="mb-6 text-2xl uppercase text-gray-777 font-roboto">Definir a senha mestre</h1>

          <div class="w-full pl-4">
            <password-input
              :showPasswordRequirements="configs.password == null"
              :error="form.errors.password"
              @updatePasswordStatus="(passwordIsValid) => this.passwordIsValid = passwordIsValid"
              v-model="form.password"
              class="mt-6 w-full lg:w-1/2"
              label="Senha" />

            <select-input v-model="form.hours" :error="form.errors.hours" class="mt-6 w-full lg:w-1/2" label="Tempo que a senha é válida">
              <option
                v-for="(value, name, index) in hoursIsValidPassword"
                :key="name"
                :value="name">
                  {{ value }}
              </option>
            </select-input>
          </div>

          <div class="mt-10 pt-4 border-t border-t-gray-777 pl-4">
            <h2 class="mb-6 text-2xl uppercase text-gray-777 font-roboto">
                Tempo de espera
            </h2>

            <p class="text-lg text-gray-777 font-roboto">
                Defina um intervalo minimo de espera para agendar uma consulta em minutos.
            </p>

            <text-input
                type="number"
                min="0"
                v-model="form.interval"
                :error="form.errors.interval"
                class="mt-6 w-full lg:w-1/2" />
          </div>

          <loading-button :loading="form.processing" class="btn-primary mt-10" type="submit">Salvar</loading-button>
        </div>

      </form>


    </div>
  </div>
</template>

<script>
import { Head, Link, useForm } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout/Layout'
import VueSelectInput from '@/Shared/Fields/VueSelectInput'
import LoadingButton from '@/Shared/Components/LoadingButton'
import PercentualInput from '@/Shared/Fields/PercentualInput'
import MoneyInput from '@/Shared/Fields/MoneyInput'
import SelectInput from '@/Shared/Fields/SelectInput'
import TextInput from '@/Shared/Fields/TextInput'

import WhatsappConnect from '@/Pages/Partials/WhatsappConnect.vue'
import PasswordInput from '@/Shared/Fields/PasswordInput'

export default {
  components: {
    Head,
    LoadingButton,
    VueSelectInput,
    PercentualInput,
    MoneyInput,
    PasswordInput,
    SelectInput,
    WhatsappConnect,
    TextInput,
  },
  props: {
    colors: Object,
    configs: Object,
    hoursIsValidPassword: Object,
  },
  remember: 'form',
  data() {
    return {
      passwordIsValid: false,

      form: useForm({
        commission_minimum_global: this.configs.commission_minimum_global,
        commission_global: this.configs.commission_global,
        interface_color_app: this.configs.interface_color_app,
        interface_color_admin: this.configs.interface_color_admin,
        interface_color_professional: this.configs.interface_color_professional,
        password: '',
        hours: this.configs.hours,

        interval: 0,
      }),
    }
  },
  layout: Layout,
  methods: {
    update() {
      this.form.put(`/config`, {
        onSuccess: () => {
          setTimeout(() => {
            window.location.reload();
          }, 500);
        },
      })
    },
  },

}
</script>

